import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { Projet } from '../../bo/projet';
import { Tir } from '../../bo/tir';
import { TypeTir } from '../../bo/TypeTir';
import { Zone } from '../../bo/zone';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { TirModaleComponent } from '../tir-modale/tir-modale.component';
import { WorkflowEtapeInstance } from 'src/app/bo/workflowEtapeInstance';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';
import posthog from 'posthog-js';

export enum EcranAffiche {
  EcranProjet,
  EcranTir,
  EcranNoeud
}

@Component({
  selector: 'app-mon-projet',
  templateUrl: './mon-projet.component.html',
  styleUrls: ['./mon-projet.component.scss'],
  animations: [
    trigger('animShowHide', [
      state('shown', style({
        opacity: 1,
      })),
      state('hidden', style({
        opacity: 0,
      })),
      transition('shown => hidden', [
        animate('0.1s')
      ]),
      transition('hidden => shown', [
        animate('0.1s')
      ]),
    ])
  ],
  standalone: false
})
export class MonProjetComponent {
  loading = signal<boolean>(false);
  startLoader = signal<any>(null);
  currentDate: Date = new Date();
  projetId = signal<number>(null);
  tirId = signal<number>(null);
  siteId = signal<number>(null);
  etapeId = signal<number>(null);
  peutCrudTir = signal<boolean>(false);
  modaleAjout = signal<BsModalRef>(null);
  showPointe = signal<boolean>(false);
  dateProjet = signal<Date>(null);
  listeTirs = signal<Tir[]>(null);
  initialisationRealisee = signal<boolean>(false);
  EcranAffiche = EcranAffiche;
  ecranAffiche = signal<EcranAffiche>(EcranAffiche.EcranProjet);
  noeudSelectionne = signal<string>(null);


  constructor(private readonly route: ActivatedRoute, private readonly http: HttpService, private readonly router: Router,
     public utilService: UtilisateurService,private readonly userProfilService : KeycloakUtilisateurService,
      private readonly modalService: BsModalService,
    private readonly fonctionsService: FonctionsService, private readonly translate: TranslateService) {
        
    if (this.utilService.currentProjet)
      this.dateProjet.set(new Date(this.utilService.currentProjet.dateFinEffective));
  }

  ngOnInit() {
    this.init();
    this.utilService.getBlastedEvent().subscribe(()=>{
      this.recupererListeTirs();
      this.init();
      })
  }

  init(){
    this.showPointe.set(false);
    this.route.params.subscribe(params => {
      this.siteId.set(params.id);
      this.projetId.set(params.projectId);
      this.synchronizeSiteFromUrl();
      
      // On ne récupère le projet que si besoin
      //if (!this.utilService.currentProjet || this.utilService.currentProjet.projetId != this.projetId) {
        //if (this.utilService.currentProjet.projetId. != this.projetId) {
        this.loading.set(true);
        this.recupProjet();
      //}
    });

    this.route.queryParams.subscribe(params => {
      this.tirId.set(params.blastId);
      this.etapeId.set(params.stepId);
      this.noeudSelectionne.set(params.nodeId);
      if (this.initialisationRealisee() && this.utilService.currentProjet && this.utilService.currentProjet.projetId == this.projetId()) {

        this.utilService.currentEtape = null;
        if (!this.tirId()) {   //pas de tir dans la route
          this.utilService.currentTir = null;
        } else if (!this.utilService.currentTir || this.utilService.currentTir.tirId != this.tirId()) {
          this.utilService.currentTir = this.utilService.currentProjet.tirs.find(p => p.tirId == this.tirId());

          if (this.etapeId()) {
            this.utilService.currentEtape = this.utilService.currentTir.workflowInstance?.workflowEtapeInstances?.find(p => p.workflowEtapeInstanceId == this.etapeId());
          }
          this.showPointe.set(false);
          setTimeout(() => {
            var tabLi = document.getElementsByClassName("item-etape");
            for (let i = 0; i < tabLi.length; i++) {
              tabLi[i].classList.add('show-etape');
              if (i == tabLi.length - 1)
                setTimeout(() => { this.showPointe.set(true); }, 150);
            }
          }, 100);
        } else if (this.etapeId()) {
          this.utilService.currentEtape = this.utilService.currentTir.workflowInstance?.workflowEtapeInstances?.find(p => p.workflowEtapeInstanceId == this.etapeId());
          this.showPointe.set(true);
        } else {
          this.ecranAffiche.set(EcranAffiche.EcranProjet);
          this.etapeId.set(-1);
        }
        this.gestionEcranAffiche();
      } else {
        if (this.tirId() !== undefined) {
          this.loading.set(true);
          this.recupProjet();
        }
      }
    });
  }

  recupProjet(isDeleted = false) {
    this.http.get<Projet>('Projects/' + this.projetId()).subscribe(projet => {
      this.loading.set(false);
      this.fonctionsService.loading_screen(false);
      if (projet == null || projet.siteId != this.siteId()) {
        this.router.navigate(['mysite', this.utilService.currentSite().siteId, 'myprojects'], { replaceUrl: true });
        return;
      }
      this.utilService.currentProjet = projet;
      console.log(this.utilService.currentProjet)
      this.dateProjet.set(new Date(this.utilService.currentProjet.dateFinEffective));
      if (this.listeTirs() === null || this.listeTirs() === undefined || isDeleted) {
        this.recupererListeTirs();
      }
      if (!this.tirId()) {   //pas de tir dans la route
        this.utilService.currentTir = null;

      } else if (!this.utilService.currentTir || this.utilService.currentTir.tirId != this.tirId()) {
        this.utilService.currentTir = this.utilService.currentProjet.tirs.find(p => p.tirId == this.tirId());

        if (this.etapeId()) {
          this.utilService.currentEtape = this.utilService.currentTir.workflowInstance?.workflowEtapeInstances?.find(p => p.workflowEtapeInstanceId == this.etapeId());
        }
        this.showPointe.set(false);
        setTimeout(() => {
          var tabLi = document.getElementsByClassName("item-etape");
          for (let i = 0; i < tabLi.length; i++) {
            tabLi[i].classList.add('show-etape');
            if (i == tabLi.length - 1)
              setTimeout(() => {
                this.showPointe.set(true);
              }, 150);

          }
        }, 100);
      } else {
        this.utilService.currentEtape = this.utilService.currentTir.workflowInstance?.workflowEtapeInstances?.find(p => p.workflowEtapeInstanceId == this.etapeId());
        this.showPointe.set(true);
      }
      this.gestionEcranAffiche();
      this.initialisationRealisee.set(true);
    }, () => {
      this.loading.set(false);
    });
  }

  tirModifie(t: Tir) {
    var id = this.utilService.currentProjet.tirs.findIndex(p => p.tirId == t.tirId);
    var d = new Date(t.dateTirEffective);
    //t.estRealise = t.dateTirEffective != null && d < this.currentDate;
    Object.assign(this.utilService.currentProjet.tirs[id], t);
    this.showPointe.set(false);
    this.recupererListeTirs();
    setTimeout(() => {
      var tabLi = document.getElementsByClassName("item-etape");
      for (let i = 0; i < tabLi.length; i++) {
        tabLi[i].classList.add('show-etape');
        if (i == tabLi.length - 1)
          setTimeout(() => { this.showPointe.set(true); }, 150);
      }
    }, 100);
  }

  onTirCree(tir: Tir) {
    this.fonctionsService.loading_screen(true);
    this.utilService.currentProjet = null;
    const targetProjetId = tir.projetId ?? this.projetId();
    forkJoin({
      tirs: this.http.get<Tir[]>('Sites/' + this.utilService.currentSite().siteId + '/Blasts'),
      projet: this.http.get<Projet>('Projects/' + targetProjetId)
    }).subscribe({
      next: ({ tirs, projet }) => {
        this.listeTirs.set(tirs);
        this.utilService.currentProjet = projet;
        this.utilService.currentTir = projet.tirs.find(t => t.tirId === tir.tirId) ?? tir;
        this.router.navigate(['mysite', this.siteId(), 'myprojects', targetProjetId], { queryParams: { blastId: tir.tirId } });
      },
      error: () => {
        this.fonctionsService.loading_screen(false);
        this.recupProjet();
      }
    });
  }

  private gestionEcranAffiche(): void {
    if (this.noeudSelectionne() !== null && this.noeudSelectionne() !== undefined && this.noeudSelectionne().length > 0) {
      this.ecranAffiche.set(EcranAffiche.EcranNoeud);
    } else if (this.tirId() !== null && this.tirId() !== undefined && this.tirId() > 0) {
      this.ecranAffiche.set(EcranAffiche.EcranTir);
    } else {
      this.ecranAffiche.set(EcranAffiche.EcranProjet);
    }
  }

  private recupererListeTirs(): void {
    this.http.get<Tir[]>('Sites/' + this.utilService.currentSite().siteId + '/Blasts').subscribe(resultat => {
      this.listeTirs.set(resultat);
    });
  }

  private synchronizeSiteFromUrl(): void {
    this.utilService.setCurrentSiteById(Number(this.siteId()));
  }

  protected isSecurityChange(event:WorkflowEtapeInstance){
    const index = this.utilService.currentTir.workflowInstance?.workflowEtapeInstances?.findIndex(w => w.workflowEtapeInstanceId === event.workflowEtapeInstanceId);
    this.utilService.currentTir.workflowInstance.workflowEtapeInstances[index].accessPermission = event.accessPermission;
   }


}
